import { render, staticRenderFns } from "./OnboardApplyDetail.vue?vue&type=template&id=27e84349&scoped=true&"
import script from "./OnboardApplyDetail.vue?vue&type=script&lang=js&"
export * from "./OnboardApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./OnboardApplyDetail.vue?vue&type=style&index=0&id=27e84349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e84349",
  null
  
)

export default component.exports